const basePath = "software-licenses/";

export const softwareLicenses = {
  id: 7,
  category: "Software & OS Licences",

  filters: {
    Brand: { type: "checkbox" },
    Version: { type: "checkbox" },
    Type: { type: "checkbox" },
  },

  subcategories: [
    {
      name: "Microsoft Windows 11 Pro",
      bestSeller: true,
      image: `${basePath}Microsoft_Windows_11_Pro.svg`,
      details: {
        Brand: "Microsoft",
        Version: "Windows 11 Pro",
        Type: "Operating System",
      },
      about: `
        <ul>
          <li>Latest Windows OS for business and personal use.</li>
          <li>Enhanced security, productivity, and performance features.</li>
        </ul>
      `,
    },
    {
      name: "Microsoft Windows Server 2022",
      bestSeller: true,
      image: `${basePath}Microsoft Windows Server 2022.jpg`,
      details: {
        Brand: "Microsoft",
        Version: "Server 2022",
        Type: "Server Operating System",
      },
      about: `
        <ul>
          <li>Enterprise-grade server OS for hybrid and cloud environments.</li>
          <li>Enhanced security and container support.</li>
        </ul>
      `,
    },
    {
      name: "Ubuntu 24.04 LTS",
      bestSeller: false,
      image: `${basePath}Ubuntu_24.04_LTS.png`,
      details: {
        Brand: "Canonical",
        Version: "24.04 LTS",
        Type: "Linux OS",
      },
      about: `
        <ul>
          <li>Open-source Linux distribution with long-term support.</li>
          <li>Ideal for servers, desktops, and cloud deployments.</li>
        </ul>
      `,
    },
    {
      name: "Red Hat Enterprise Linux 9",
      bestSeller: false,
      image: `${basePath}Red_Hat_Enterprise_Linux_9.png`,
      details: {
        Brand: "Red Hat",
        Version: "RHEL 9",
        Type: "Enterprise Linux OS",
      },
      about: `
        <ul>
          <li>Enterprise Linux distribution with advanced security and management features.</li>
        </ul>
      `,
    },
    {
      name: "Microsoft Office 2021 Pro Plus",
      bestSeller: true,
      image: `${basePath}Microsoft_Office_2021_Pro_Plus.svg`,
      details: {
        Brand: "Microsoft",
        Version: "Office 2021 Pro Plus",
        Type: "Productivity Suite",
      },
      about: `
        <ul>
          <li>Full-featured Microsoft Office suite for professional productivity.</li>
        </ul>
      `,
    },
    {
      name: "Adobe Creative Cloud",
      bestSeller: true,
      image: `${basePath}Adobe_Creative_Cloud.jfif`,
      details: {
        Brand: "Adobe",
        Version: "Creative Cloud",
        Type: "Design & Creativity Suite",
      },
      about: `
        <ul>
          <li>Industry-standard suite for design, video, and web development.</li>
        </ul>
      `,
    },
    {
      name: "VMware vSphere 8",
      bestSeller: true,
      image: `${basePath}VMware_vSphere_8.png`,
      details: {
        Brand: "VMware",
        Version: "vSphere 8",
        Type: "Virtualization Platform",
      },
      about: `
        <ul>
          <li>Enterprise virtualization platform for cloud and data center environments.</li>
        </ul>
      `,
    },
    {
      name: "Oracle Database 21c Enterprise Edition",
      bestSeller: true,
      image: `${basePath}Oracle_Database_21c.jpg`,
      details: {
        Brand: "Oracle",
        Version: "21c Enterprise Edition",
        Type: "Database Management System",
      },
      about: `
        <ul>
          <li>High-performance database platform for enterprise applications.</li>
        </ul>
      `,
    },
    {
      name: "SQL Server 2022 Standard",
      bestSeller: true,
      image: `${basePath}SQL_Server_2022_Standard.png`,
      details: {
        Brand: "Microsoft",
        Version: "SQL Server 2022 Standard",
        Type: "Database Management System",
      },
      about: `
        <ul>
          <li>Reliable relational database management system with advanced analytics.</li>
        </ul>
      `,
    },
    {
      name: "GitHub Enterprise",
      bestSeller: true,
      image: `${basePath}GitHub_Enterprise.png`,
      details: {
        Brand: "GitHub",
        Type: "Version Control Platform",
      },
      about: `
        <ul>
          <li>Enterprise-grade source code management and collaboration platform.</li>
        </ul>
      `,
    },
    {
      name: "AWS Enterprise Support",
      bestSeller: true,
      image: `${basePath}AWS_Enterprise_Support.png`,
      details: {
        Brand: "Amazon Web Services",
        Type: "Cloud Support",
      },
      about: `
        <ul>
          <li>Comprehensive enterprise-level support for AWS cloud services.</li>
        </ul>
      `,
    },
    {
      name: "Microsoft Azure Enterprise",
      bestSeller: true,
      image: `${basePath}Microsoft_Azure_Enterprise.png`,
      details: {
        Brand: "Microsoft",
        Type: "Cloud Platform",
      },
      about: `
        <ul>
          <li>Enterprise cloud computing services for building, testing, and managing applications.</li>
        </ul>
      `,
    },
    {
      name: "ServiceNow ITSM",
      bestSeller: true,
      image: `${basePath}ServiceNow_ITSM.svg`,
      details: {
        Brand: "ServiceNow",
        Type: "IT Service Management",
      },
      about: `
        <ul>
          <li>Platform for IT service management, workflows, and automation.</li>
        </ul>
      `,
    },
    {
      name: "SUSE Linux Enterprise Server",
      bestSeller: true,
      image: `${basePath}SUSE_Linux.png`,
      details: {
        Brand: "SUSE",
        Type: "Enterprise Linux OS",
      },
      about: `
        <ul>
          <li>Enterprise Linux distribution with scalability, security, and support features.</li>
        </ul>
      `,
    },
    {
      name: "VMware Workstation Pro",
      bestSeller: true,
      image: `${basePath}Vmware_workstation_16_icon.svg.png`,
      details: {
        Brand: "VMware",
        Type: "Desktop Virtualization",
      },
      about: `
        <ul>
          <li>Virtualization software for running multiple operating systems on a single desktop.</li>
        </ul>
      `,
    },
    {
      name: "AutoCAD 2024",
      bestSeller: true,
      image: `${basePath}AutoCAD_2024.png`,
      details: {
        Brand: "Autodesk",
        Version: "2024",
        Type: "CAD Software",
      },
      about: `
        <ul>
          <li>Industry-standard software for 2D and 3D design and drafting.</li>
        </ul>
      `,
    },
    {
      name: "SolidWorks 2023",
      bestSeller: true,
      image: `${basePath}SolidWorks_2023.png`,
      details: {
        Brand: "Dassault Systèmes",
        Version: "2023",
        Type: "CAD Software",
      },
      about: `
        <ul>
          <li>Powerful 3D mechanical design and simulation software.</li>
        </ul>
      `,
    },
    {
      name: "Adobe Substance 3D Painter",
      bestSeller: true,
      image: `${basePath}Adobe_Substance_3D_Painter.png`,
      details: {
        Brand: "Adobe",
        Type: "3D Rendering & Texturing",
      },
      about: `
        <ul>
          <li>3D texturing software for creating high-quality materials and textures.</li>
        </ul>
      `,
    },
    {
      name: "Autodesk Maya 2024",
      bestSeller: true,
      image: `${basePath}Autodesk_Maya_2024.png`,
      details: {
        Brand: "Autodesk",
        Version: "2024",
        Type: "3D Animation & Modeling",
      },
      about: `
        <ul>
          <li>Professional software for 3D animation, modeling, simulation, and rendering.</li>
        </ul>
      `,
    },
    {
      name: "Norton 360 Deluxe",
      bestSeller: true,
      image: `${basePath}Norton_360_Deluxe.png`,
      details: {
        Brand: "Norton",
        Type: "Antivirus & Security",
      },
      about: `
        <ul>
          <li>Comprehensive antivirus and internet security solution.</li>
        </ul>
      `,
    },
    {
      name: "Bitdefender Total Security",
      bestSeller: true,
      image: `${basePath}Bitdefender_Total_Security.png`,
      details: {
        Brand: "Bitdefender",
        Type: "Antivirus & Security",
      },
      about: `
        <ul>
          <li>Advanced antivirus and cybersecurity protection for all devices.</li>
        </ul>
      `,
    },
    {
      name: "V-Ray for 3ds Max",
      bestSeller: true,
      image: `${basePath}V-Ray_for_3ds_Max.png`,
      details: {
        Brand: "Chaos Group",
        Type: "Rendering Software",
      },
      about: `
        <ul>
          <li>Professional rendering engine for photorealistic visualizations in 3ds Max.</li>
        </ul>
      `,
    },
    {
      name: "KeyShot 12",
      bestSeller: true,
      image: `${basePath}KeyShot_12.svg`,
      details: {
        Brand: "Luxion",
        Version: "12",
        Type: "3D Rendering Software",
      },
      about: `
        <ul>
          <li>Fast and easy 3D rendering and animation software for designers and engineers.</li>
        </ul>
      `,
    },
  ],
};
